<template>
    <div></div>
</template>

<script>
  export default {
    name: 'MissingComponent'
  }
</script>

<style scoped>

</style>